module.exports = __webpack_public_path__ + "static/media/NWB_children_video_cover.5ca78892.jpg";